//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import { commonService } from "../../_services";
import config from '../../config';
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import { bannersActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    tableImg: {
        width: '50px',
        height: '50px',
        position: 'relative',
        padding: '3px'
    },

    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    },
    borderedImgTable: {
        position: 'relative',
        width: '52px',
        height: '52px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '8px',
        marginRight: '8px'
    }
});

class Banners extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            banners: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            bannerAdd: false,
            shopKeeperData: [],
            title: '',
            bannerError: '',
            bannerSuccess: '',
            getBannersList: [],
            addCat: false,
            editingCatId: '',
            editingCatTitle: '',
            editingCatStatus: '',
            editingCatHold: false,
            bannerImage: '',
            banner_type: '',
            allActiveCat: [],
            perPage: config.perPageData,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the banners data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;

        dispatch(bannersActions.getBannersList(apiConstants.GET_BANNERS, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { dispatch } = props;
        if (props.deleteBanner.deleteBanner !== undefined &&
            props.deleteBanner.deleteBanner.data !== undefined &&
            props.deleteBanner.deleteBanner.data.data !== undefined &&
            props.deleteBanner.deleteBanner.data.success === true) {

            if (this.state.triggerDelete === true) {

                this.setState({ triggerDelete: false });
                this.setState({ deletingBanner: '', openDeleteCat: false });

                let postData = {};
                postData.page = this.state.currentPage;
                postData.orderBy = "id";
                postData.orderByAscDesc = "ASC";
                postData.perPage = this.state.perPage;
                dispatch(bannersActions.getBannersList(apiConstants.GET_BANNERS, postData));
            }
        }

        //check if banner already exist with same name
        if (
            props.saveBanner !== undefined &&
            props.saveBanner.savedBanner !== undefined &&
            props.saveBanner.savedBanner === false
        ) {
            this.setState({ bannerError: 'Banner with same name already exist!!', bannerSuccess: '', bannerImage_error: '', bannerDescriptionError : '' })
        }

        //IF banner ADDED SUCCESSFULLY
        if (
            props.saveBanner !== undefined &&
            props.saveBanner.savedBanner !== undefined &&
            props.saveBanner.savedBanner.data !== undefined &&
            props.saveBanner.savedBanner.data.success !== undefined &&
            props.saveBanner.savedBanner.data.success === true
        ) {
            const thisHolder = this;
            if (thisHolder.state.addCat === true) {
                this.setState({ bannerSuccess: 'Banner added successfully!!', bannerError: '', bannerImage_error: '', bannerDescriptionError : '' });

                setTimeout(function () {

                    thisHolder.setState({ bannerSuccess: '', bannerError: '', bannerImage_error: '', bannerDescriptionError : '' });
                    thisHolder.closeAddCatPop();

                    let postData = {};
                    postData.page = thisHolder.state.currentPage;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = thisHolder.state.perPage;
                    dispatch(bannersActions.getBannersList(apiConstants.GET_BANNERS, postData));
                }, 2000);
            }
        }


        // GET LIST OF CATEGORIES SUCCESS
        if (props.getBannersList !== undefined &&
            props.getBannersList.getBannersList !== undefined &&
            props.getBannersList.getBannersList.data !== undefined
        ) {
            const bannerDataReceived = props.getBannersList.getBannersList.data;
            this.setState({
                getBannersList: bannerDataReceived,
                totalPage: bannerDataReceived.pagination.totalPages,
                totalDataCount: bannerDataReceived.pagination.totalCount,
            })
        }
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });
        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPage;
        dispatch(bannersActions.getBannersList(apiConstants.GET_BANNERS, postData));
    }


    //remove image while editing a category
    removeMainImage = () => { this.setState({ editingCatLogo: '' }); }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (banners, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ banners, [type]: true })
    };


    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            banners: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    //on change set category title to state
    onChangeCatTitle = (e) => {
        if (e.target.type === "file") {

            var extArr = ["image/jpeg", "image/jpg", "image/png"];
            const files = e.target.files;
            const target = e.target;
            var forimgState = [target.name + "_error"];


            if (extArr.indexOf(files[0].type) > -1) {

                this.setState({ [target.name]: files[0] });

                // let img = new Image()
                // img.src = window.URL.createObjectURL(e.target.files[0])
                // img.onload = () => {

                //     if (img.width === 161 && img.height === 139) {
                //         this.setState({ [target.name]: files[0] });
                //         this.setState({ [forimgState]: "" });
                //         // upload logic here
                //     }
                //     else {
                //         this.setState({ [forimgState]: "Image dimension should not be greater then 169*139!!" });
                //         target.value = null;
                //         this.setState({ [target.name]: '' })
                //     }
                // }


            } else {
                this.setState({ [forimgState]: "One of the file type not suported" })
                e.target.value = null;
                this.setState({ [e.target.name]: '' })
            }
        }
        else { this.setState({ [e.target.name]: e.target.value }); }
    }

    //close add category popup
    closeAddCatPop = () => {
        this.setState({
            bannerSuccess: '',
            bannerAdd: false,
            title: '',
            addCat: false
        });
    }

    //save banner to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        this.setState({ bannerError: '', bannerImage_error: '', bannerType_error: '', bannerDescriptionError : '' });
        const { title, parentcat, bannerImage, banner_type, description } = this.state;
        if (title === undefined || title === '') { this.setState({ bannerError: 'Banner title required!!' }) }
        else if (description === undefined || description === '') { this.setState({ bannerDescriptionError: 'Banner decription required!!' }) }
        else if (bannerImage === undefined || bannerImage === '') { this.setState({ bannerImage_error: 'Banner Image required!!' }) }
        else if (banner_type === undefined || banner_type === '') { this.setState({ bannerType_error: 'Banner Type required!!' }) }
        else {

            this.setState({ bannerError: '', addCat: true, bannerImage_error: '', bannerType_error: '', bannerDescriptionError : '' })

            const postData = {};
            postData.title = title;
            postData.banner_type = banner_type;
            postData.description = description;

            if (parentcat !== undefined) {
                postData.parentcat = parentcat;
            }

            //add to form data to send over api
            const logoImage = new FormData();
            logoImage.append('bannerImage', bannerImage);

            commonService.withTokenAndFormData(apiConstants.SAVE_BANNER_IMAGE, logoImage).then(
                res => {
                    //get image title from response
                    if (res.data !== undefined && res.data.data !== undefined) {
                        postData.banner_image = res.data.data;
                    }
                    // save banner data to cololection
                    dispatch(bannersActions.saveBanner(apiConstants.SAVE_BANNERS, postData));
                },
                error => { }
            );
        }
    }


    openAddCategory = () => {
        this.setState({
            bannerAdd: !this.state.bannerAdd,
            bannerSuccess: '',
            title: '',
            parentcat: '',
            bannerImage: '',
            banner_type: '',
            bannerImage_error: '',
            bannerType_error: '',
            addCat: false
        });

    }

    // handleClose = () => {
    //     this.setState({ bannerAdd: !this.state.bannerAdd })
    // };


    deletePopupOpen = (bannerId) => {
        this.setState({ deletingBanner: bannerId, openDeleteCat: true });
    }

    closeDeletePopup = (bannerId) => {
        this.setState({ deletingBanner: '', openDeleteCat: false });
    }

    // after conform click to delete banner
    deletingCatRecord = () => {
        this.setState({ triggerDelete: true });

        const { dispatch } = this.props;
        const postData = {};
        postData.bannerId = this.state.deletingBanner;
        dispatch(bannersActions.deleteBanners(apiConstants.DELETE_BANNER, postData));
    }

    onChangeHandleField = (e) => { this.setState({ [e.target.name]: e.target.value }); }


    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_BANNERS}
                                </li>
                                <li style={{ paddingLeft: "800px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_BANNERS}</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddCategory()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">

                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_TITLE}</th>
                                                    <th>{siteConstants.GEN_DESCRIPTION}</th>
                                                    <th>Type</th>
                                                    <th>{siteConstants.GEN_IMAGE}</th>
                                                    <th scope="col" width="10%">{siteConstants.LABEL_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getBannersList.data != undefined &&
                                                        this.state.getBannersList.data.length > 0 ?
                                                        this.state.getBannersList.data.map((thisbanner, index) => {
                                                            let stText = 'Active';
                                                            if (thisbanner.status === 0) { stText = 'Deactive'; }

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisbanner.title}</td>
                                                                    <td> {thisbanner.description}</td>
                                                                    <td> {thisbanner.banner_type}</td>
                                                                    <td>
                                                                        {
                                                                            thisbanner.banner_image !== undefined && thisbanner.banner_image ? (
                                                                                <div className={classes.borderedImgTable}>
                                                                                    <img src={`${config.imgPath}` + '/uploads/banners/' + thisbanner.banner_image} className={classes.tableImg} />
                                                                                </div>
                                                                            ) : '--'
                                                                        }

                                                                    </td>

                                                                    <td>{stText}</td>
                                                                    <td>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisbanner._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="6" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add banner popup */}
                    <Dialog
                        open={this.state.bannerAdd}
                        aria-labelledby="banner-title"
                        aria-describedby="save-banner-description"
                    >
                        <DialogTitle id="crop-image-dialog-title" className={classes.root}>{siteConstants.LABEL_ADD_BANNERS}</DialogTitle>
                        <DialogContent className={classes.contentRoot}>
                            <div class="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_TITLE}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder={siteConstants.GEN_TITLE}
                                            className="form-control"
                                            name="title"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.bannerError}</p>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>Banner Type</label>
                                        <select  className="form-control" name="banner_type" onChange={(e) => this.onChangeHandleField(e)} value={this.state.banner_type}>
                                        <option value=""></option>
                                        <option value="HomeTopBanner">HomeTopBanner</option>
                                        <option value="HomeBottomBanner">HomeBottomBanner</option>
                                        <option value="HomeTopImage">HomeTopImage</option>
                                        <option value="HomeBottomImage">HomeBottomImage</option>
                                        </select>
                                        <p style={{ color: 'red' }}>{this.state.bannerType_error}</p>
                                    </div>
                                </div>

                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.GEN_DESCRIPTION}</label>
                                        <input
                                            type="text"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            placeholder={siteConstants.GEN_DESCRIPTION}
                                            className="form-control"
                                            name="description"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.bannerDescriptionError}</p>
                                    </div>
                                </div>


                                <div className="col-md-12 col-xs-12">
                                    <div className="form-group">
                                        <label>{siteConstants.LABEL_BANNER_IMAGE}</label>
                                        <input
                                            type="file"
                                            onChange={(e) => this.onChangeCatTitle(e)}
                                            className="form-control"
                                            name="bannerImage"
                                        />
                                        <p style={{ color: 'red' }}>{this.state.bannerImage_error}</p>
                                        <p style={{ color: 'green' }}>{this.state.bannerSuccess}</p>
                                    </div>
                                </div>


                            </div>
                        </DialogContent>


                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                            <Button variant="contained" onClick={() => this.closeAddCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit banner popup */}




                    {/* notify about delete */}
                    <Dialog open={this.state.openDeleteCat} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingCatRecord(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, saveBanner,getBannersList, addBanner, deleteBanner } = state;
    return {
        language,
        saveBanner,
        getBannersList,
        addBanner,
        deleteBanner
    };
}

export default connect(mapStateToProps)(withStyles(styles)(Banners));
